import { DomainContext, AccountContextValue, ClientContextValue, HouseholdContextValue, GroupContextValue } from '@pershing/pershing-core';
import { NxiContextResponse } from '../models/nxi-context-response.model';

export class NxiContextUtils {
    static getContextFromDomainValue(domainContext: DomainContext<any>): NxiContextResponse {
        let response: NxiContextResponse = new NxiContextResponse();
        let contextValue = domainContext.value;
        if (contextValue instanceof AccountContextValue) {
            response.inputValue = contextValue.accountNumber;
            response.hashValue = contextValue.hashValue;
        } else if (contextValue instanceof ClientContextValue) {
            response.inputValue = contextValue.clientId;
        } else if (contextValue instanceof HouseholdContextValue || contextValue instanceof GroupContextValue) {
            response.inputValue = contextValue.groupId;
            response.hashValue = contextValue.hashValue; // For HH and Group
        } else {
            response.inputValue = '';
        }
        return response;
    }
}
